import { createContext, useContext, useDebugValue } from 'react';
import { Tooltip as UITKTooltip } from '@jpmuitk/tooltip';
import { getWithDefault } from './internal/getWithDefault';
var TooltipContext = /*#__PURE__*/createContext();
export default TooltipContext;
/**
 * Provide defaults for Tooltip config so that we can maintain the consistency
 * if no customized override is provided
 */

export var useTooltipContext = function useTooltipContext() {
  var context = useContext(TooltipContext) || {};
  useDebugValue("".concat(context && context.Tooltip !== undefined ? 'Customized' : 'Default UIToolkit', " Tooltip"));
  return {
    Tooltip: getWithDefault(context.Tooltip, UITKTooltip),
    enterDelay: getWithDefault(context.tooltipEnterDelay, 1500),
    leaveDelay: getWithDefault(context.tooltipLeaveDelay, 0),
    placement: getWithDefault(context.tooltipPlacement, 'top')
  };
};